<template>
  <div class="" id="page-approved-jobs-emp">
    <div class="applied-jobs">
      <div v-if="progressBar">
        <v-progress-linear
          class="prog"
          height="3"
          :indeterminate="true"
        ></v-progress-linear>
      </div>
      <div v-if="!noData" class="row search-results">
        <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 list-result">
          <div class="job-list-wrapper">
            <div class="header-text">
              <div class="ttl">Approved Jobs</div>
              <div class="sub-ttl">Showing {{ jobs.length }} jobs</div>
            </div>
            <div style="height: 100%" class="row" v-if="loading">
              <div class="my-auto mx-auto">
                <v-progress-circular
                  :size="70"
                  :width="3"
                  color="primary"
                  indeterminate
                ></v-progress-circular>
              </div>
            </div>
            <div class="row job-list" :key="changeJob">
              <div
                @click="viewThisJob(job, index)"
                v-bind:class="{ activeJob: isActive(index) }"
                class="job"
                :key="index"
                v-for="(job, index) in jobs"
              >
                <job-synopsis v-bind:job="job"> </job-synopsis>
              </div>
            </div>
          </div>
          <div v-if="load_more" class="pagination-wrapper">
            <div class="pagination">
              <div @click="pagination" class="load-more">Load more</div>
            </div>
          </div>
        </div>
        <div
          class="col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8 job-preview-wrapper"
          v-if="!phone"
        >
          <div :key="changeView" class="job-preview">
            <about-job
                    v-bind="viewJobProps"
                    v-bind:company_id="company_id"
            ></about-job>
          </div>
        </div>
      </div>
      <div v-if="noData && errMsg" class="row no-result no-padding">
        <div class="mx-auto my-auto">
          <img
            class="no-result-image"
            src="../../../../assets/newDesign/no-approved-job.svg"
          />
          <div class="no-result-color">
            <b>Sorry {{ errMsg }}</b>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import JobSynopsis from "../job-synops-card";
import AboutJob from "../about-the-job";
import { JOB } from "../../../../Api/employer_api";
import { PHONE } from "../../../../globalFunctions";
export default {
  name: "active-jobs",
  components: {
    JobSynopsis,
    AboutJob
  },
  props: {
    company_id: String
  },
  data: function() {
    return {
      phone: PHONE(),
      progressBar: true,
      page: 1,
      pageStart: 0,
      pageCount: 5,
      edit: false,
      noData: true,
      errMsg: "",
      jobs: [],
      viewJobProps: {
        page: "approved"
      },
      changeView: 0,
      changeJob: 0,
      currentIndex: null,
      currentJob: null,
      lastKey: null,
      loading: false,
      totalCount: null,
      load_more: false
    };
  },

  methods: {
    getActiveJobs: function() {
      const self = this;
      let params = {
        status: "approved",
        key: self.lastKey
      };
      if(self.company_id) {
        params.company_id = self.company_id
      }
      self.loading = true;
      JOB(params)
        .then(function(response) {
          self.progressBar = false;
          if (response.status === 200) {
            self.loading = false;
            if (response.data.jobs.length > 0) {
              self.totalCount = response.data.jobs.length;
              self.jobs = self.jobs.concat(response.data.jobs);
              self.viewThisJob(self.jobs[0], 0);
              self.noData = false;
              if (response.data.last_evaluated_key) {
                self.lastKey = response.data.last_evaluated_key;
                self.load_more = true;
              } else {
                self.load_more = false;
              }
            } else {
              self.noData = true;
              self.errMsg = "you have no approved job";
            }
          } else {
            self.loading = false;
            self.noData = true;
            self.errMsg = "you have no approved job";
          }
        })
        .catch(function(err) {
          self.loading = false;
          self.progressBar = false;
          self.noData = true;
          self.errMsg = err.message;
        });
    },
    viewThisJob: function(job, index) {
      this.viewJobProps.job = job;
      this.changeView++;
      this.currentIndex = index;
      this.currentJob = job;
    },
    isActive(index) {
      return this.currentIndex === index;
    },
    pagination: function() {
      this.getActiveJobs();
    }
  },
  mounted() {
    const self = this;
    self.getActiveJobs();
  }
};
</script>

<style scoped>
.applied-jobs {
  min-height: 90vh;
}
.prog {
  margin: 0;
}
.no-result {
  margin: 2.5rem !important;
  height: 80vh;
  /*border: .1rem solid #fc3832;*/
  box-shadow: 0 0 0.2rem 0 rgba(0, 0, 0, 0.16);
}
.no-result-color {
  margin-top: 1rem;
  font-size: 2.4rem;
  color: var(--button-delete-color);
}
.no-result-image {
  width: 30rem;
}
.list-result {
  padding: 0;
  border-radius: 0.8rem;
  box-shadow: 0 0 0.2rem 0 rgba(0, 0, 0, 0.16);
  background-color: #ffffff;
}
.header-text {
  background-color: #fafafa;
  padding: 1.5rem;
  position: absolute;
  top: 0;
  z-index: 2;
  width: 100%;
  text-align: left;
}
.ttl {
  font-size: 2rem;
  font-weight: bold;
  line-height: 1.25;
  color: #050405;
}
.sub-ttl {
  font-size: 1.4rem;
  line-height: 1.25;
  text-align: left;
  color: rgba(5, 5, 5, 0.6);
}
.job-list-wrapper {
  padding: 7rem 0;
  /*background-color: #ffffff;*/
  height: 90vh;
  overflow: scroll;
}
.job-list {
  background-color: #ffffff;
}
.job {
  width: 100%;
}
.job-preview-wrapper {
  height: 90vh;
  padding: 0 0 0 3.2rem;
}
.job-preview {
  height: 100%;
  /*border: .2rem solid red;*/
  border-radius: 0.8rem;
  box-shadow: 0 0 0.2rem 0 rgba(0, 0, 0, 0.16);
  /*background-color: #ffffff;*/
}
.pagination-wrapper {
  width: 100%;
  position: absolute;
  bottom: 0;
  padding: 1rem 0 2rem 0;
  border-radius: 0.8rem 0;
  background-color: #ffffff;
}
.pagination {
  display: flex;
  justify-content: center;
}
/* .loadMore-wrapper {
  padding: 4.0rem 0 2.0rem 0;
  text-align: center;
}
.loadMore {
  border: .1rem transparent;
  border-radius: .3rem;
  background-color: #11998e;
  padding: 1.0rem;
  color: #ffffff;
  font-size: 1.4rem;
  cursor: pointer;
} */
/* .activeJob {
  cursor: pointer;
  background-color:var(--synop-select-color);
  border-left: .2rem solid var(--link-color);
} */
.load-more {
  background-color: var(--button-color);
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  cursor: pointer;
  color: white;
}
@media (max-width: 600px) {
  .job-list-wrapper {
    height: auto;
  }
}
</style>
